import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalCloseButton, DateTimePicker, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { subDays } from 'date-fns';
import { useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { StaticToast } from 'src/common/components/static-toast';
import { StyledModalTitle, StyledTextField } from '../add-seat-modal/add-seat-modal.styles';
import { CorpSideButton, StyledButtonIcon } from '../../corporate.styles';
import { UpdateRenewDashboardData, BaseModalProps } from '../../corporate.types';
import { useRenewDashboardMutation } from '../../corporate.slice';
import { planInfo, planWarning } from '../../corporate.constants';
export const RenewPlansModal = ({
  companyId,
  icon
}: BaseModalProps) => {
  const [updateRenewDashboard] = useRenewDashboardMutation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [date, setDate] = useState<Date | null>();
  const {
    register,
    reset,
    handleSubmit
  } = useForm<UpdateRenewDashboardData>({
    defaultValues: {
      companyId: '',
      renewalDate: ''
    }
  });
  const onSubmit = async () => {
    try {
      await updateRenewDashboard({
        companyId,
        renewalDate: date?.toString() ?? ''
      }).unwrap();
      NotificationDispatch('success', 'Plan Renewed successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
    reset();
    handleModalClose();
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  return <Modal onOpenChange={open => {
    setModalOpen(open);
    reset();
  }} open={modalOpen} overflowVisible preventOnOpenAutoFocus triggerElement={<CorpSideButton color="secondary" variant="outlined">
          <StyledButtonIcon icon={icon} size="lg" />
          Renew plans
        </CorpSideButton>} isSmall data-sentry-element="Modal" data-sentry-component="RenewPlansModal" data-sentry-source-file="renew-plans-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="renew-plans-modal.tsx">
        <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="renew-plans-modal.tsx">Renew plan</StyledModalTitle>
      </ModalHeader>

      <StaticToast type="info" message={planInfo} data-sentry-element="StaticToast" data-sentry-source-file="renew-plans-modal.tsx" />
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id="renew-plan" method="dialog" onSubmit={handleSubmit(onSubmit)}>
        <StyledTextField data-sentry-element="StyledTextField" data-sentry-source-file="renew-plans-modal.tsx">
          <DateTimePicker {...register('renewalDate')} label="Dashboard renewal date *" selected={date} placeholderText="None selected" minDate={subDays(new Date(), 30)} timeIntervals={15} isClearable shouldCloseOnSelect autoComplete="off" onChange={newDate => setDate(newDate)} required data-sentry-element="DateTimePicker" data-sentry-source-file="renew-plans-modal.tsx" />
        </StyledTextField>
        <StaticToast type="warning" message={planWarning} data-sentry-element="StaticToast" data-sentry-source-file="renew-plans-modal.tsx" />
        <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="renew-plans-modal.tsx">
          <ModalCloseButton text="Cancel" handleCloseButtonAction={() => reset()} data-sentry-element="ModalCloseButton" data-sentry-source-file="renew-plans-modal.tsx" />
          <Button type="submit" color="primary" variant="solid" data-sentry-element="Button" data-sentry-source-file="renew-plans-modal.tsx">
            Renew Plan
          </Button>
        </ModalFooter>
      </form>
    </Modal>;
};